const tipoCaptura = [
  { label: 'Numérico', id: 'numerico' },
  { label: 'Texto', id: 'texto' },
];

export default tipoCaptura;
